import { render, staticRenderFns } from "./BtnResource.vue?vue&type=template&id=1baad77b&"
import script from "./BtnResource.vue?vue&type=script&lang=js&"
export * from "./BtnResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports